import { UserConsumer } from '../../core/providers/UserProvider';
import { Typography } from '@material-ui/core';
import SuggestionMiniDisplay from './SuggestionMiniDisplay';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import GS from '../../grafsync/grafsync';
import { STATUS_PENDING } from '../utils/constants';

class SuggestionInlineDisplay extends React.Component {

  render() {

    const { suggestionItems, graph, existingValues, schemeIRI, projectIRI, useXL, showSuggestion,
      isReadOnly, useWorkflow, components, users, suggestionProp, title } = this.props;

    // This works because on first render there must be one to get this far
    // On subsequent renders they will then all be loaded
    const isPendingSuggestion = suggestionItems[suggestionProp].find(s => {
      if (GS.isLoaded(s, graph)) {
        const data = GS.data(s, graph);
        return data && data.status[0] === STATUS_PENDING;
      }
      return true;
    });

    return (
      <UserConsumer>
        {({ user }) =>
          <div data-test="inline-suggestions">
            {isPendingSuggestion &&
              <Typography data-test="label-suggestions" variant="caption" style={{ color: '#01579B' }}>{title}</Typography>
            }
            {suggestionItems[suggestionProp].map(sa => {
              return <SuggestionMiniDisplay
                schemeIRI={schemeIRI}
                projectIRI={projectIRI}
                isReadOnly={isReadOnly}
                useWorkflow={useWorkflow}
                useXL={useXL}
                user={user.id}
                components={components}
                key={sa}
                users={users}
                onShowSuggestion={showSuggestion}
                existingValues={existingValues}
                id={sa}
                graph={graph} />;
            })}
          </div>
        }
      </UserConsumer>
    );
  }
}

SuggestionInlineDisplay.defaultProps = {
  title: "Suggestions"
};


SuggestionInlineDisplay.propTypes = {
  schemeIRI: PropTypes.string,
  projectIRI: PropTypes.string.isRequired,
  optionForXL: PropTypes.bool,
  suggestionProp: PropTypes.string.isRequired,
  useXL: PropTypes.bool,
  showSuggestion: PropTypes.func.isRequired,
  useWorkflow: PropTypes.bool,
  users: PropTypes.array.isRequired,
  components: PropTypes.array.isRequired,
  entitlements: PropTypes.array.isRequired,
  iriOptions: PropTypes.object,
  defaultLang: PropTypes.string.isRequired,
  classes: PropTypes.object,
  graph: PropTypes.string.isRequired,
  existingValues: PropTypes.object,
  suggestionItems: PropTypes.object.isRequired
};

export default withStyles(styles)(SuggestionInlineDisplay);